<template>
  <div
    id="scrollTop"
    class="Practice h-72 lg:h-screen bg-white text-black pt-12 flex flex-wrap"
  >
    <h1 class="text-transparent fixed">Architect Serving Launceston and Devonport</h1>
    <div
      :style="{ backgroundImage: 'url('+imageSrc+')' }"
      class="w-full lg:w-2/5 h-full bg-cover bg-center flex items-end justify-end"
    >
      <p
        @click="scrollToBottom"
        class="text-white mr-10 mb-8 cursor-pointer uppercase text-xs tracking-widest font-sansBold font-medium"
      >
        Scroll Down
      </p>
    </div>
    <div
      class="hidden lg:block w-3/5 h-full p-10"
    >
      <AccordianTwo ref="childComponentBig" @onClick="updateContent" :accordianData="accordianData" showNameInContent />
    </div>
    <div class="flex lg:hidden w-full px-8 justify-center mt-10">
      <Accordian ref="childComponentSmall" @onClick="updateContent" :accordianData="accordianData" showNameInContent />
    </div>

    <div
      id="scrollBottom"
      v-if="currentSlideName==='Our Studio'"
      class="flex flex-wrap"
    >
      <div class="px-10 lg:px-40 w-full flex flex-wrap py-24 justify-center">
        <div class="mb-10 lg:mb-0 px-5 lg:px-10 pb-20 h-auto lg:h-full w-full lg:w-4/12 border-l border-black">
          <h6 class="text-sm uppercase">Objectives</h6>
          <p class="text-xs lg:text-base leading-6 lg:leading-9">
            Brief, Site Location, Local Elements, Human Value, Tailored, Collaborative, Dynamic.
          </p>
        </div>
        <div class="mb-10 lg:mb-0 px-5 lg:px-10 pb-20 h-auto lg:h-full w-full lg:w-2/12 border-l border-black">
          <h6 class="text-sm uppercase">Our Commitment</h6>
          <p class="text-xs lg:text-base leading-6 lg:leading-9">
            You, the client.
          </p>
        </div>
        <div class="mb-10 lg:mb-0 px-5 lg:px-10 pb-20 h-auto lg:h-full w-full lg:w-6/12 border-l border-black">
          <h6 class="text-sm uppercase">Memberships</h6>
          <p class="text-xs lg:text-base leading-6 lg:leading-9">
            Association of Building Sustainability Assessors Australian Institute of Architects
          </p>
        </div>
      </div>
      <div class="px-10 lg:px-40 w-full">
        <div class="w-64 border-t border-black mb-10"></div>
      </div>
      <div class="px-10 lg:pl-40 w-full flex">
        <p class="w-full lg:w-1/2 text-xs">
          We are driven by the brief, site location, local elements and human value. We believe that working collaboratively alongside clients and consultants with effective communication, ensures that the brief is ultimately addressed and realised. Our designs are individual, site specific and client driven with character, purpose and individuality that are intimately connected to the client.
          <br />
          <br />
          We are committed to understanding you, the client, and realise that ultimately the client has ownership of the outcome. We share and discuss collaboratively to ensure that we understand not only the vision and end goal, but the details that we know are important to you. We respond to the context of the site in a dynamic manner that is both relevant and appropriate to create a built form that is physically beautiful and enriches the lives of it’s occupants pragmatically and aesthetically.
          <br />
          <br />
          We are always conscious of passive environmentally sustainable design principles which include consideration of the material palette and the manner in which the building elements are connected to the surrounding environment.
        </p>
      </div>
    </div>

    <div
      v-if="currentSlideName==='The Team'"
      class="w-full px-8 lg:px-40 py-24"
    >
      <div v-for="(person, index) in staff" :key="index"
        class="flex"
      >
        <div class="mb-12 mr-4 md:mr-12 h-96 w-64 bg-cover bg-center" :style="{ backgroundImage: 'url(' + person.imageSrc + ')' }">
        </div>
        <div class="w-1/2">
          <div class="w-full mb-2">
            <div class="w-10 border-t border-black"></div>
          </div>
          <div>
            <h6 class="text-base md:text-xl">{{person.name}}</h6>
            <p class="uppercase text-xs md:text-base">{{person.title}}</p>
            <span class="personDescription" v-html="person.description"></span>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="currentSlideName==='Services'"
      class="w-full"
    >
      <div class="px-10 lg:px-40 w-full flex flex-wrap py-24 justify-center">
        <div class="mb-10 lg:mb-24 px-5 lg:px-10 pb-20 h-auto lg:h-full w-full lg:w-1/2 border-l border-black">
          <h6 class="text-base">Typologies</h6>
          <p class="text-xs lg:text-base">
            Residential, Commercial, Public, Tourism/ Hospitality and Masterplanning
          </p>
        </div>
        <div class="mb-10 lg:mb-24 px-5 lg:px-10 pb-20 h-auto lg:h-full w-full lg:w-1/2 border-l border-black">
          <h6 class="text-base">Locations</h6>
          <p class="text-xs lg:text-base">
            Devonport Launceston Hobart Burnie
          </p>
        </div>
        <div class="mb-10 lg:mb-24 px-5 lg:px-10 pb-20 h-auto lg:h-full w-full lg:w-1/2 border-l border-black">
          <h6 class="text-base">Architecture Design Services</h6>
          <p class="text-xs lg:text-base">
            Starbox Architecture is a premier architecture firm. We provide multidisciplinary architecture design services to help you throughout the design process of your project, and our architects work closely with you to bring about the unique vision you have for your project.
          </p>
        </div>
        <div class="mb-10 lg:mb-24 px-5 lg:px-10 pb-20 h-auto lg:h-full w-full lg:w-1/2 border-l border-black">
          <h6 class="text-base">Discover</h6>
          <p class="text-xs lg:text-base">
            Our work focuses on beautiful buildings that enrich the lives of the occupants by being both practical and aesthetically pleasing. We believe that true architecture design should be functional and beautiful and that neglecting one or the other leaves your building lacking.
            <br />
            <br />
            We also use sustainable design principles throughout our process to ensure that your design has minimal impact on the world around us. We don’t only focus on using environmentally friendly materials—we also strive to integrate our buildings into the surrounding environment in a safe and sustainable way.
          </p>
        </div>
        <div class="mb-10 lg:mb-24 px-5 lg:px-10 pb-20 h-auto lg:h-full w-full lg:w-1/2 border-l border-black">
          <h6 class="text-base">Schedule a Meeting</h6>
          <p class="text-xs lg:text-base">
            As a boutique architecture firm, we build not only buildings but also relationships. We strive to create spaces together with you by collaborating throughout the design process. We share and discuss ideas with you from the beginning to develop a stunning and sustainable design.
            <br />
            <br />
            Our team invests time and thought into your project to bring about the best result. We know that the best outcome depends on our collaboration, and we do all our work with that commitment in mind.
            <br />
            <br />
            Schedule a meeting with an architect at Starbox Architecture today. Call 036424 7736 or complete our contact form.
          </p>
        </div>
        <div class="mb-10 lg:mb-24 px-5 lg:px-10 pb-20 h-auto lg:h-full w-full lg:w-1/2">
        </div>
      </div>
    </div>

    <div
      v-if="currentSlideName==='Publications & Awards'"
      class="w-full"
    >
      <div class="px-10 lg:px-40 w-full flex flex-wrap py-24 justify-center">
        <div v-for="(feature, index) in features" :key="index" class="mb-10 lg:mb-24 px-5 lg:px-10 pb-20 h-auto lg:h-full w-full lg:w-1/2 border-l border-black flex flex-wrap">
          <div class="w-full">
            <h6 class="text-base">{{feature.name}}</h6>
            <p class="text-xs lg:text-base">
              {{feature.description}}
            </p>
          </div>
          <div v-if="feature.link_url&&feature.name" class="flex mt-4">
            <CustomButtonTwo @onClick="goToLink(feature.link_url)" dark>{{feature.link_name}}</CustomButtonTwo>
          </div>
        </div>
      </div>
    </div>

    <div class="w-full flex flex-wrap items-end justify-between pb-24 mt-16 lg:mt-0">
      <div class="mb-10 sm:mb-0">
        <div
          v-for="(file, index) in files" :key="index"
        >
          <a :href="file.path" target="_blank" class="ml-10 lg:ml-40 border-2 border-black cursor-pointer flex justify-center items-center py-4 px-10 mb-2">
            <span :href="file.path" class="uppercase font-sansBold text-base" target="_blank">{{file.name}}</span>
          </a>
        </div>
      </div>
      <div class="w-64">
        <CustomButtonFour class="mb-2" @onClick="openAccordian(accordianData[2])" dark>
          Services
        </CustomButtonFour>
        <CustomButtonFour class="mb-2" @onClick="openAccordian(accordianData[0])" dark>
          Our Studio
        </CustomButtonFour>
        <CustomButtonFour class="mb-2" @onClick="openAccordian(accordianData[1])" dark>
          The Team
        </CustomButtonFour>
        <CustomButtonFour @onClick="openAccordian(accordianData[3])" dark>
          Publications & Awards
        </CustomButtonFour>
      </div>
    </div>

  </div>
</template>

<script>
// @ is an alias to /src
import axios from 'axios'
import AccordianTwo from '@/components/elements/AccordianTwo.vue'
import Accordian from '@/components/elements/Accordian.vue'
import CustomButtonFour from '@/components/elements/CustomButtonFour.vue'
import CustomButtonTwo from '@/components/elements/CustomButtonTwo.vue'
var VueScrollTo = require('vue-scrollto')

export default {
  name: 'practice',
  components: {
    AccordianTwo,
    Accordian,
    CustomButtonFour,
    CustomButtonTwo
  },
  metaInfo () {
    return {
      title: 'Architecture in Devonport & Launceston | Starbox Architecture',
      meta: [
        {
          name: 'description',
          content: 'Starbox Architecture is a team of Devonport-based architects that serve individuals around Launceston. Visit us online to get started!'
        },
        {
          name: 'keywords',
          content: 'starbox,architecture,starbox architecture,tasmania,tasmanian,tasmanian architecture,tasmania architecture'
        }
      ]
    }
  },
  data () {
    return {
      currentSlideName: 'Services',
      features: [],
      staff: [],
      files: [],
      accordianData: [
        {
          name: 'Services',
          content: 'As a boutique architecture firm, we build not only buildings but also relationships.'
        },
        {
          name: 'Our Studio',
          content: `We are driven by the brief, site location, local elements and human value.
          <div class="mt-6 flex flex-wrap w-full justify-between">
            <div class="w-16 md:w-24 md:mt-2">
              <img src="/img/member-absa-logo.jpg" alt="Architect Launceston Architect Devonport">
            </div>
            <div class="w-16 md:w-24 md:mt-2">
              <img src="/img/member-maioa_black.jpg" alt="Architect Launceston Architect Devonport">
            </div>
            <div class="w-16 md:w-24 md:mt-2">
              <img src="/img/ArchiTeam_Member_White.jpg" alt="Architect Launceston Architect Devonport">
            </div>
            <div class="w-16 md:w-24 md:mt-2">
              <img class="w-12" src="/img/LHD Assessor Logo black and white 2.jpg" alt="Architect Launceston Architect Devonport">
            </div>
          </div>`
        },
        {
          name: 'The Team',
          content: 'We are committed to understanding you, the client, and realise that ultimately the client has ownership of the outcome.'
        },
        {
          name: 'Publications & Awards',
          content: 'We are always conscious of passive environmentally sustainable design principles.'
        }
      ]
    }
  },
  computed: {
    imageSrc () {
      var toReturn = ''
      if (this.currentSlideName === 'Our Studio') toReturn = '/img/starbox_architecture-frederick-internal-3344.jpg'
      else if (this.currentSlideName === 'The Team') toReturn = '/img/starbox_architecture-studio-3327.jpg'
      else if (this.currentSlideName === 'Services') toReturn = '/img/starbox_architecture-wesley-interior-6731.jpg'
      else if (this.currentSlideName === 'Publications & Awards') toReturn = '/img/starbox_architecture-joyce_st-external-2708.jpg'
      return toReturn
    }
  },
  methods: {
    goToProject (project) {
      this.$router.replace('/project/' + project.index)
    },
    updateContent (slideName) {
      this.currentSlideName = slideName
    },
    openAccordian (slide) {
      this.$refs.childComponentBig.selectSlide(slide)
      this.$refs.childComponentSmall.selectSlide(slide)
      this.scrollToTop()
    },
    scrollToTop () {
      VueScrollTo.scrollTo('#scrollTop', '500', {})
    },
    scrollToBottom () {
      VueScrollTo.scrollTo('#scrollBottom', '500', {})
    },
    getStaff () {
      var toReturn = []
      axios.get(process.env.VUE_APP_ROOT_API + '/staff').then(response => {
        var data = response.data
        for (var i = 0; i < data.length; i++) {
          toReturn.push({
            name: data[i].name,
            title: data[i].title,
            description: data[i].description
          })
          if (data[i].image) toReturn[i].imageSrc = data[i].image.path
        }
        this.staff = toReturn
      }).catch(error => {
        console.log('Error', error)
      })
    },
    getFeatures () {
      var toReturn = []
      axios.get(process.env.VUE_APP_ROOT_API + '/features').then(response => {
        var data = response.data
        for (var i = 0; i < data.length; i++) {
          toReturn.push({
            id: data[i].id,
            name: data[i].name,
            description: data[i].description,
            link_url: data[i].link_url,
            link_name: data[i].link_name
          })
        }
        this.features = toReturn
      }).catch(error => {
        console.log('Error', error)
      })
    },
    getFiles () {
      var toReturn = []
      axios.get(process.env.VUE_APP_ROOT_API + '/files').then(response => {
        var data = response.data
        for (var i = 0; i < data.length; i++) {
          toReturn.push({
            id: data[i].id,
            name: data[i].name
          })
          if (data[i].actual_file) toReturn[toReturn.length - 1].path = data[i].actual_file.path
        }
        this.files = toReturn
      }).catch(error => {
        console.log('Error', error)
      })
    },
    goToLink (url) {
      window.open(url, '_blank')
    }
  },
  mounted () {
    this.getStaff()
    this.getFeatures()
    this.getFiles()
  },
  beforeDestroy () {
  }
}
</script>

<style lang="scss">
  $sm: '640px';
  $md: '768px';
  $lg: '1024px';
  $xl: '1280px';
  $xxl: '1920px';

  .Practice {
    .personDescription {
        p {
          font-size: 0.875rem;
        }

      @media (min-width: $md) {
        p {
          font-size: 1rem;
        }
      }
    }
  }
</style>
